/**
 * @typedef { import('../../../time.js').YearMonthPeriodObject } YearMonthPeriodObject
 */

import {Report} from './report.js';
import {Cohort} from './report.js';

import {convertObjectToYearMonthPeriod} from '../../../time.js';
import {parseYearMonth} from '../../../time.js';

/**
 * @typedef {Object} ReportObject
 * @property {YearMonthPeriodObject} period
 * @property {?CohortObject[]} cohorts
 */

/**
 * @param {ReportObject} reportObject 
 * @returns {?Report}
 */
 export function parseReport(reportObject) {
  const period = convertObjectToYearMonthPeriod(reportObject.period);
  if(period === null) {
    return null;
  }

  let cohorts = null;
  const cohortObjects = reportObject.cohorts;
  if(cohortObjects !== null) {
    const parsedCohorts = parseCohorts(cohortObjects);
    if(parsedCohorts === null) {
      return null; // parsing error
    }
    cohorts = parsedCohorts;
  }

  return new Report(period, cohorts);
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} CohortObject
 * @property {string} month
 * @property {number} size
 * @property {MetricObject[]} metrics
 */

/**
 * @param {CohortObject[]} cohortObjects
 * @returns {?Map<string, Cohort>}
 */
 function parseCohorts(cohortObjects) {
  /** @type {Map<string, Cohort>} */
  const cohorts = new Map();

  for(const cohortObject of cohortObjects) {
    const cohort = parseCohort(cohortObject);
    if(cohort === null) {
        return null; // parsing error
    }
    cohorts.set(cohort.getName(), cohort);
  }

  return cohorts;
}

/**
 * @param {CohortObject} cohortObject
 * @returns {?Cohort}
 */
function parseCohort(cohortObject) {
  const ym = parseYearMonth(cohortObject.month);
  if(ym === null) {
    return null; // parsing error
  }

  const size = cohortObject.size;

  const metrics = parseMetrics(cohortObject.metrics);
  if(metrics === null) {
    return null; // parsing error
  }

  return new Cohort(ym, size, metrics);
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} MetricObject
 * @property {string} month
 * @property {number} value
 */

/**
 * @param {MetricObject[]} metricObjects
 * @returns {?Map<string, number>}
 */
 function parseMetrics(metricObjects) {
  /** @type {Map<string, number>} */
  const metrics = new Map();

  for(const metricObject of metricObjects) {
    const ym = parseYearMonth(metricObject.month);
    if(ym === null) {
      return null;
    }

    const ymStr = ym.toString();
    metrics.set(ymStr, metricObject.value);
  }

  return metrics;
}
